import { render, staticRenderFns } from "./PromotionsViewBulk.vue?vue&type=template&id=d311843c&"
import script from "./PromotionsViewBulk.vue?vue&type=script&lang=js&"
export * from "./PromotionsViewBulk.vue?vue&type=script&lang=js&"
import style0 from "./PromotionsViewBulk.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports